import React, { useState } from 'react';
import { WaitlistForm } from '../components/WaitlistForm';
import { WaitlistStats } from '../components/WaitlistStats';
import { useWaitlistCount } from '../hooks/useWaitlistCount';
import { CheckCircle2 } from 'lucide-react';

function About() {
  const [submitted, setSubmitted] = useState(false);
  const { count, name: currentTier, spots: remainingSpots } = useWaitlistCount();
  const goalSignups = 1500;
  const progress = (count / goalSignups) * 100;

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gray-900 text-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 md:mb-8 leading-tight">
              Det borde vara enklare att hitta och söka rätt finansiering
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
              Vår mission är att demokratisera tillgången till bidrag och finansieringsmöjligheter med hjälp av artificiell intelligens.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8">Vår historia</h2>
              <div className="space-y-6 text-base md:text-lg leading-relaxed">
                <p className="text-gray-600">
                  Det började med en frustration som många entreprenörer känner igen - den tidskrävande processen att hitta rätt bidrag och sedan författa ansökningar som uppfyller alla kriterier och använder rätt nyckelord.
                </p>
                <p className="text-gray-600">
                  Vi såg hur många lovande projekt och innovativa idéer aldrig fick chansen att blomstra, helt enkelt för att processen att söka finansiering var för komplex och tidskrävande. Timmar som kunde ha använts till att utveckla produkter och nå kunder gick istället till att navigera genom en labyrint av bidragsansökningar.
                </p>
                <p className="text-gray-600">
                  Det var då vi fick idén att skapa något revolutionerande - en AI-driven copilot som kan tränas på över 60 000 framgångsrika svenska bidragsansökningar. Genom att analysera denna omfattande datamängd kan vi skapa ett verktyg som inte bara hittar de mest relevanta bidragen för din situation, utan också vägleder dig genom hela ansökningsprocessen.
                </p>
                <p className="text-gray-600">
                  Vår vision är att demokratisera tillgången till finansiering. Vi tror att briljanta idéer förtjänar att bli verklighet, oavsett grundarens tidigare erfarenhet av bidragsansökningar. Med Utlysningslabbet vid din sida kan du fokusera på det som verkligen betyder något - att bygga och utveckla ditt företag.
                </p>
                <p className="text-gray-600">
                  Låt oss tillsammans förändra hur svenska startups och entreprenörer får tillgång till finansiering. Framtiden är här, och den är tillgänglig för alla.
                </p>
              </div>
            </div>
            <div className="order-first md:order-last">
              <img
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=600"
                alt="Teamsamarbete"
                className="rounded-3xl shadow-2xl w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4">
          {!submitted ? (
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100">
              <WaitlistStats className="mb-6" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                Få exklusiv förhandsåtkomst och 6 månader gratis
              </h3>
              <p className="text-gray-600 mb-6 text-center">
                Endast {remainingSpots} platser kvar med {currentTier === 'Grundare' ? '6' : currentTier === 'Pionjär' ? '2' : '1'} månader gratis användning och livstids VIP-support
              </p>
              <WaitlistForm onSuccess={() => setSubmitted(true)} />
            </div>
          ) : (
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg text-center">
              <div className="flex items-center justify-center gap-3 mb-2">
                <CheckCircle2 className="text-green-500" size={28} />
                <p className="text-gray-900 font-semibold text-xl">
                  Grattis! Du är nu registrerad som {currentTier}
                </p>
              </div>
              <p className="text-gray-600 text-lg">
                Vi håller dig uppdaterad om projektets utveckling.
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default About;